import React from 'react';
import callApi from './../../utils/apicaler';
import Checkbox from '@material-ui/core/Checkbox';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import NavMeauBar from './const_childer/nav_meau';
import '.././puclic/scss/style.css';    
import Proce from '../pageCreate/Proce';
import axios from 'axios';   
import {
  Link,
  Redirect
} from "react-router-dom";

    
class ManagerPage extends React.Component{
    constructor(props){
            super(props);

            this.state = {
                products : [],
                loader:"",
                showMeau:"",
                heyConten:"",
                active:true,
                redirct:0,
                showProductOpacity:"",
                showProductImage:"",
                showProductName:"",
                onshowProductImage:"",
                file:"",
                alertCustom:"",
                views:[],
                isTrueLogin:false,
                status:0,
                resStatus:0,
                sale:"",
                salePrice:"",
                saleErr:""
            }
        }


    componentDidMount(){
    	callApi('5f1db609a8ghgherwexcuy55jee4200b0bff191', 'GET', null).then(res =>{
			this.setState({
				products : res.data.posts,
				views : res.data.views,
				status:res.status
			})
		})

		axios.get('https://planet-time-linseed.glitch.me/')
            .then((res)=> {
                this.setState({
					resStatus:res.status
				})
            })

		const cookie = document.cookie
		 if(cookie === "0fe8cf3262d72131ec5d304cd3d8190b"){
		 	this.setState({isTrueLogin : true})
		 }


    }

    deleteCall = (id) =>{
    	var {products} = this.state;
    	callApi(`delete/${id}`, 'GET', null).then(res =>{
	   			if( res.status === 200){
	   				var index = this.findIndex(products, id);
	   				if(index !== -1){
	   					products.splice(index, 1);
	   					this.setState({
	   						products:products
	   					})
	   				}
	   			}
			})
    }
    deleteCallViews = (id) =>{
    	var {views} = this.state;
    	callApi(`deleteviews/${id}`, 'GET', null).then(res =>{
	   			if( res.status === 200){
	   				var index = this.findIndex(views, id);
	   				if(index !== -1){
	   					views.splice(index, 1);
	   					this.setState({
	   						views:views
	   					})
	   				}
	   			}
			})
    }

    onDelete = (id) =>{
		
	   	if(confirm('ban co chan chan muon xoa ? ')){ // eslint-disable-line
	   		{this.deleteCall(id)}
	   		
	   	}
		
	}

	onDeleteViews = (id) =>{
		
	   	if(confirm('ban co chan chan muon xoa ? ')){ // eslint-disable-line
	   		{this.deleteCallViews(id)}
	   		
	   	}
		
	}

	findIndex = (products, id) =>{
		var result = -1;
			products.forEach((post, index)=>{
				if(post._id === id){
					result = index;
				}
			})
		return result;
	}
	showMeau = () =>{
		this.setState({
			showMeau:"showMeau",
			heyConten:"heyConten"
		})
	}
	closeMeau = () =>{
		this.setState({
			showMeau:"",
			heyConten:""
		}) 
	}
	showProduct=(name, image)=>{
		// console.log(name)
		this.setState({ showProductOpacity: "showProductOpacity", onshowProductImage:"onshowProductImage" ,showProductImage:image,	showProductName:name })
	}
	closeIconeImg=()=>{
		this.setState({ showProductOpacity: "", onshowProductImage:"" })
	}

	onChangeImage1=(e)=>{
        let file = e.target.files[0];
          this.setState({
            file: file
          }); 
    }
    onChangeSale=(e)=>{
        this.setState({
            sale: e.target.value
          }); 
        console.log(e.target.value)
    }
    onChangePriceSale=(e)=>{
        this.setState({
            salePrice: e.target.value
          }); 
        console.log(e.target.value)
    }

    updateSale=(id)=>{
    	let {sale, salePrice} = this.state;
        // this.setState({alertCustom : "alertCustom"})

            axios.post(`https://t5f1805b29d37b001382761af.herokuapp.com/sale/${id}`,{
            	sale:sale,
            	salePrice:salePrice
            })
                .then((res)=> {
                	if(res.status === 200){
                		if(sale === "SALE"){
                			this.setState({saleErr : "Sale thành công"})
                		}else{
                			this.setState({saleErr : "Tắt sale thành công"})
                		}
                    	

                	}
                })
                .catch((err)=> {
                    console.log(err);
          
				})

                 setTimeout(function(){ window.location.href = "/manager"; }, 3000);
			

        }


    showTableImgConten =(datas, showProductName)=>{
    	var result = null;
	    	result = datas.map((product, index)=>{
	    		return ( 
				    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4" id={ product.products === showProductName ? "" : "display_not"} key={index}>
						<div className="conten_image_product1" >
							<img style={ product.price ? {display:"none"} : {}} src={product.imgeFile1} />
							<Checkbox style={ product.price ? {display:"none"} : {position:"absolute",left:"70%"}} onClick={()=> this.onDeleteViews(product._id)}/>
						</div>
					</div>
	    		)
	    	})
		return result;
	}

	showTable =(datas)=>{
    	var result = null;
	    	result = datas.map((product, index)=>{
	    		return ( 
				    <tr key={index} id={ product.off === "off" ? "display_not" : ""}>
				      <th scope="row">{index + 1}</th>
				      <td>
				      	<img src={ this.state.resStatus === 200 ?  product.imgeFile : "https://cdn.glitch.com/1a2d3926-a597-412c-a998-a0aa2ca0b31a%2FUntitled%20design%20(8).gif?v=1595782003844"} style={{width:"50px", height:"50px"}} />
				      </td>
				      <td >{product.products}</td>
				      <td>{` ${product.price}.000 Vnd`}</td>
				      <td>{product.conten}</td>
				      <td>
					      	<select style={{width:"120px", border:"none", color:product.sale === "SALE" ? "red" : ""}} defaultValue={'DEFAULT'} className="form-control input-custom" id="inlineFormCustomSelect" onChange={this.onChangeSale} name="sale">
	                            <option value="DEFAULT" disabled>{product.sale === "SALE" ? "Đang Sale" : "chua sale"}</option>
	                        	<option defaultValue="1">SALE</option>  
	                        	<option defaultValue="1">SALE NO</option>  
	                        	<option defaultValue="1">HET HANG</option>  
	                        </select>
	                        	<select defaultValue={'DEFAULT'} style={{width:"50px", border:"none"}} onChange={this.onChangePriceSale}>
	                        		<option value="DEFAULT" disabled>{product.salePrice}%</option>
	                        		<option defaultValue="1">10%</option>  
	                        		<option defaultValue="1">20%</option> 
	                        		<option defaultValue="1">30%</option> 
	                        		<option defaultValue="1">40%</option> 
	                        		<option defaultValue="1">50%</option> 
	                        		<option defaultValue="1">60%</option> 
	                        		<option defaultValue="1">70%</option> 
	                        	</select>
				      		
				      </td>
				      <td>
				      	<button onClick={()=> this.updateSale(product._id)}>Update</button>	 
				      </td>
				      <td>
				      	<Checkbox onClick={()=> this.onDelete(product._id, product.imgeFile)}/>
				      		<div>
				      			<Link to={`addProduct/${product._id}`}>
				      				<i className="fas fa-plus"></i>
				      			</Link>
				      		</div>
				      </td>
				    </tr>
	    		)
	    	})
		return result;
	}




    render(){
		const {resStatus,saleErr, status, isTrueLogin, views, alertCustom, linkto, products, loader, showMeau, heyConten, redirct, showProductOpacity, showProductImage, onshowProductImage, showProductName} = this.state

    	var wapper = <div id={alertCustom}>
		        		{ status === 200 ? 
		        			<div>
		        			<div className={`showProductImage ${onshowProductImage}`}>
			        			<div className="close_imgc1" onClick={this.closeIconeImg}><CloseIcon/> </div>
				        			<div className="conten_image_product">
				        				<img src={`https://planet-time-linseed.glitch.me/${showProductImage}`} />
				        				<div className="row">
				        					{this.showTableImgConten(views, showProductName)}
				        					<input name="imgeFile1" className="form-control" type="file" onChange={this.onChangeImage1} />
				        					<button type="submit" onClick={()=> this.callApiFunc(showProductName)} className="btn btn-default">button</button>
				        				</div>
				        			</div>
				        		</div>
								<div className={`container-fluid ${showProductOpacity}`}>
							    	<div className="row custom_row">
							    		<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
							    			<div className="wapper">
							    				<div className={`nav_bar ${showMeau}`}>
							    					<h3>elsoule</h3>
							    					<hr/>
							    					<NavMeauBar active={this.state.active}/>
							    				</div>
							    				<div className={`conten ${heyConten}`}>
							    						{ heyConten === "heyConten" ? <div className="meau_mobi" onClick={this.closeMeau}> <CloseIcon /> </div> : <div className="meau_mobi" onClick={this.showMeau}> <MenuIcon /> </div> }
							    					<h3>Table List</h3>
		        									<p style={{textAlign:"center", color:"#31cd3e"}}>{saleErr}</p>
							    					<div className="table_list">
							    						<table className="table table-striped">
														  <thead>
														    <tr>
														      <th scope="col">ID</th>
														      <th scope="col">Image</th>
														      <th scope="col">Product</th>
														      <th scope="col">Price</th>
														      <th scope="col">Species</th>
														      <th scope="col">Master</th>
														    </tr>
														  </thead>
														  <tbody>
															{this.showTable(products)}
														  </tbody>
														</table>
							    					</div>
							    				</div>
							    			</div>
							    		</div>
							    	</div>
							    </div>	

						    </div>		    
		        			: <div className="loader loader-black loader-1"></div>
		        		}
		        		
					</div>	
		var notFaul = <div style={{color:"red", fontSize:"20px", textAlign:"center"}}>Dừng lại! </div>
        return(
        	<div>{isTrueLogin === true ? wapper : notFaul}</div>		    
        	)
    }
    
}

export default ManagerPage;